var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { canUseDOM } from 'exenv';
import { authTrackOverride } from './track';
import { track } from '@food/tracking';
var maxRetry = 10;
export var oAuthLogin = function (_a) {
    var socialType = _a.socialType;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            track(__assign(__assign({}, authTrackOverride), { action: { type: 'auth_getting_social_token', socialType: socialType } }));
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    // se siamo sul server non possiamo loggarci, semplicemente esco.
                    if (!canUseDOM) {
                        reject(new Error('Server side cannot try login!'));
                        return;
                    }
                    var retryCount = 0;
                    var authWin = window.open(socialType.loginURL(), 'OAUTH2');
                    var timerId = setInterval(function () {
                        return __awaiter(this, void 0, void 0, function () {
                            var codeUri, matches, code;
                            return __generator(this, function (_a) {
                                try {
                                    if (authWin && typeof authWin.opener === 'object') {
                                        // if user closed authWin stop awaiting auth
                                        try {
                                            if (authWin.location.pathname !== 'blank') {
                                                codeUri = authWin.location.search;
                                                clearInterval(timerId); // when user get back after remote auth on our domain we again have access to authWin properties
                                                matches = /\?code=([^&#]+)/.exec(codeUri);
                                                if (matches) {
                                                    code = matches[1];
                                                    authWin.close();
                                                    clearInterval(timerId);
                                                    resolve(decodeURIComponent(code));
                                                }
                                                else {
                                                    retryCount += 1;
                                                    if (retryCount === maxRetry) {
                                                        //authWin.close();
                                                        clearInterval(timerId);
                                                    }
                                                }
                                            }
                                        }
                                        catch (err) {
                                            console.warn(err);
                                            // waiting for user back
                                            // IMPORTANT non va catchato perche' chrome restituisce un errore CORS per localhost, url social e auth.gruppofood.com
                                        }
                                    }
                                    else {
                                        clearInterval(timerId);
                                    }
                                }
                                catch (e) {
                                    clearInterval(timerId);
                                    reject(e);
                                }
                                return [2 /*return*/];
                            });
                        });
                    }, 100);
                })];
        });
    });
};
//# sourceMappingURL=oauth.js.map